import { CreateCorrectionPayload } from "@/api/types";

export const setMaskToField = (field: string) => Number(field).toFixed(4);

interface CorrectionToMask {
  Tinh: number;
  Rinh: number;
  Rexh: number;
  "%CO2inh": number;
  "%CO2exh": number;
  CO2V: number;
  "Vent.V": number;
}

const correctionToMask = (correction: CorrectionToMask) => {
  return Object.entries(correction).reduce((sum, [key, value]) => {
    // @ts-ignore
    sum[key] = setMaskToField(value);
    return sum;
  }, {} as CreateCorrectionPayload);
};

export default correctionToMask;
